export const EQUIP_STATUS = {
  available: { label: "Available", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  on_hire: { label: "On Hire", cls: "bg-blue-100 text-blue-800 border-blue-300" },
  off_hire: { label: "Off Hire", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  under_repair: { label: "Under Repair", cls: "bg-orange-100 text-orange-800 border-orange-300" },
  quarantined: { label: "Quarantined", cls: "bg-purple-100 text-purple-800 border-purple-300" },
  lost: { label: "Lost", cls: "bg-red-100 text-red-700 border-red-300" },
};

export const BLOCKING_STATUSES = ["under_repair", "quarantined", "lost"];

export const TEXT_FIELDS = [
  "asset_id", "make_model", "serial_number", "wll", "cert_valid_date", "calibration_valid_date",
  "accessories", "inspection_due_date", "test_due_date", "last_inspection_date",
  "revenue_splits", "weight_dimensions", "asset_owner",
];

export const DATE_FIELDS = [
  ["cert_valid_date", "Current certification valid until"],
  ["calibration_valid_date", "Calibration certificate valid until"],
  ["inspection_due_date", "Inspection due date"],
  ["test_due_date", "Test / certification due date"],
  ["last_inspection_date", "Last inspection date"],
];

export const emptyEquip = {
  name: "", category: "", location: "", description: "", quantity: 1, status: "available",
  daily_rate: "", weekly_rate: "", monthly_rate: "", replacement_value: "",
  ...Object.fromEntries(TEXT_FIELDS.map((f) => [f, ""])),
};

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(`${d}T00:00:00`);
  return isNaN(dt) ? d : dt.toLocaleDateString("en-NZ", { day: "2-digit", month: "short", year: "numeric" });
};

export const localToday = () => {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
};

export const isPastDue = (d) => !!d && d < localToday();

export const DUE_FIELDS = ["inspection_due_date", "test_due_date", "cert_valid_date", "calibration_valid_date"];

const plusDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const dueState = (e) => {
  const dates = DUE_FIELDS.map((f) => e[f]).filter(Boolean);
  if (dates.some((d) => isPastDue(d))) return "overdue";
  const horizon = plusDays(30);
  return dates.some((d) => d <= horizon) ? "soon" : null;
};

export const StatusBadge = ({ status, testid }) => {
  const s = EQUIP_STATUS[status] || EQUIP_STATUS.available;
  return (
    <span data-testid={testid} className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 border whitespace-nowrap shrink-0 ${s.cls}`}>
      {s.label}
    </span>
  );
};
